<template>
    <div>
        <slot name="activator" v-bind:on="open"></slot>

        <b-modal ref="modal" title="แก้ไข" hide-footer>
            <div>
                <b-form-group label="Return Date">
                    <b-form-datepicker
                        v-model="form.return_date"
                        locale="en"
                    ></b-form-datepicker>
                </b-form-group>

                <b-form-group label="Reason">
                    <b-form-select v-model="form.return_reason">
                        <b-select-option v-for="value in items" :value="value" :key="value">{{ value }}</b-select-option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label="Reason detail (Option)">
                    <b-form-textarea v-model="form.return_reason_detail" ></b-form-textarea>
                </b-form-group>

                <div class="d-flex justify-content-end">
                    <b-btn type="button" variant="outline-secondary" @click.prevent="$refs.modal.hide()">Cancel</b-btn>
                    <b-btn type="button" variant="success" class="ml-2" @click.prevent="onSave" :disabled="saving || invalid">Save</b-btn>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {

        props: {
            tracking: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                saving: false,
                items: [
                    'ที่อยู่ไม่ถูกต้อง',
                    'ไม่มีผู้รับสินค้า',
                    'สินค้าชำรุด',
                    'สินค้าผิดรุ่นหรือไม่ถูกต้อง',
                ],
                form: {
                    return_date: moment().format('YYYY-MM-DD'),
                    return_reason: 'ที่อยู่ไม่ถูกต้อง',
                    return_reason_detail: ''
                }
            }
        },

        computed: {
            invalid() {
                return this.form.return_date.length === 0
                    || this.form.return_reason.length === 0
            }
        },

        methods: {
            open() {
                this.$refs.modal.show()
            },

            close() {
                this.$refs.modal.hide()
            },

            async onSave() {
                this.saving = true

                try {
                    await axios.patch(`/tracking/${this.$props.tracking.id}`, {
                        action: 'return',
                        ...this.form
                    })

                    this.close()
                    window.location.reload()
                } catch (e) {
                    window.alert(e.message)
                }

                this.saving = false
            }
        }
    }
</script>
